import { AxiosPromise } from 'axios';

import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { datadogRum } from '@datadog/browser-rum';

type getDashboardHtttpResponseBody = any;

const axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);

const makeHttpRequest = (
  body: any,
  path: string
): AxiosPromise<getDashboardHtttpResponseBody> => {
  return axios.http.post(`Metabase/PostgenericA/` + path, body);
};
export const saveImport = (data: any): AxiosPromise => {
  return axios.http.post(
    'Metabase/PostgenericA/conecta_matriz_producto_comercial/process_excel',
    data
  );
};
export const fetchReportesSerie = (body: any, path: string) =>
  makeHttpRequest(body, path);
